import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import SelectField from '@wix/da-ds/pkg/Dropdown/select/SelectField';
import { ArtsAndCraftsDeviationFieldName } from '../../types';

/* TODO: Replace with actual galleries fetched from the user's gallery list */
const PLACEHOLDER_GALLERIES = [{ value: 'featured', label: 'Featured' }];

const GalleryField: React.FC<{}> = () => {
  const { t } = useTranslation();
  const id = useId();
  const { control } = useFormContext();
  const { field } = useController({
    name: ArtsAndCraftsDeviationFieldName.GALLERY,
    control,
  });

  return (
    <SelectField
      id={id}
      label={t('artsAndCraftsDeviationPopup.form.gallery.label')}
      items={PLACEHOLDER_GALLERIES}
      value={field.value ?? 'featured'}
      onSelect={field.onChange}
      noBottomSpacing
    />
  );
};
GalleryField.displayName = 'GalleryField';

export default GalleryField;
